module.exports = __webpack_public_path__ + "static/media/bg25.87015097.jpg";